import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import ProdutoFornecedor from "model/administracao/cadastro/produto/ProdutoFornecedor";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ProdutoFornecedorService implements BaseServiceCadastros<ProdutoFornecedor> {

    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/produtoFornecedor/pesquisar`;
            if (filter) {
                url += getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<ProdutoFornecedor>((resolve, reject): void => {
            api
                .get(`/produtoFornecedor/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(produtoFornecedor: ProdutoFornecedor) {
        return new Promise<ProdutoFornecedor>((resolve, reject): void => {
            let url = `/produtoFornecedor/incluir`;
            api
                .post(url, JSON.stringify(produtoFornecedor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(produtoFornecedor: ProdutoFornecedor) {
        return new Promise<ProdutoFornecedor>((resolve, reject): void => {
            api
                .put(`/produtoFornecedor/editar`, JSON.stringify(produtoFornecedor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/produtoFornecedor/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/produtoFornecedor/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    familias() {
        return new Promise<Array<FamiliaProduto>>((resolve, reject): void => {
            api
                .get(`/produtoFornecedor/familias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    fornecedores(){
        return new Promise<Array<Pessoa>>((resolve, reject): void => {
            api
                .get(`/produtoFornecedor/fornecedores`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    planosInspecao(){
        return new Promise<Array<PlanoInspecao>>((resolve, reject): void => {
            api
                .get(`/produtoFornecedor/planosInspecao`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ProdutoFornecedorService;
